import { defineStore } from 'pinia';
import type { RegisterData, ValidationData } from '@/types/register';

const registerStore = () => {
  const { socialEmail, socialToken, isSocialAuthFlow } = useAuthSocial();

  const isLoading = ref<boolean>(false);
  const initialValidationData: ValidationData = {
    errors: 0,
    fields: {
      userId: false,
      name: false,
      nationalities: false,
      email: isSocialAuthFlow.value ? !!socialEmail.value : false,
      email_confirm: isSocialAuthFlow.value ? !!socialEmail.value : false,
      ddi: false,
      phone: false,
      affiliation_code: false,
      birth_date: false,
      document: false,
      country_data: true,
      city: false,
      address: false,
      state: false,
      zipcode: false,
      password: isSocialAuthFlow.value ? !!socialToken.value : false,
      optIn: false,
    },
  };

  const initialRegisterData: RegisterData = {
    userId: '',
    name: '',
    nationalities: [],
    email: isSocialAuthFlow.value ? socialEmail.value : '',
    email_confirm: isSocialAuthFlow.value ? socialEmail.value : '',
    ddi: '',
    phone: '',
    affiliation_code: '',
    birth_date: '',
    document: '',
    country_data: useRuntimeConfig().public.brand.country,
    city: '',
    address: '',
    state: '',
    zipcode: '',
    password: isSocialAuthFlow.value ? socialToken.value : '',
    optIn: ['bonusConsent'],
  };

  const validationData = ref<ValidationData>({ ...initialValidationData });
  const registerData = ref<RegisterData>({ ...initialRegisterData });

  function $reset() {
    validationData.value = { ...initialValidationData };
    registerData.value = { ...initialRegisterData };
  }

  return {
    isLoading,
    validationData,
    registerData,
    $reset,
  };
};

export const useRegisterStore = defineStore('register', registerStore);
